import React from 'react';
import MapLayer from './component';

export default React.memo(MapLayer);
